import { Intercom } from '@intercom/messenger-js-sdk'
import { useEffect } from 'react'
import { useMe } from '../me'
import { GetConfigVarsDocument } from '../../generated/graphql'
import { useQuery, useReactiveVar } from '@apollo/client'
import { globalViewPanelIds } from '../../cache'
import { VIEW_PANEL_WIDTH } from '../../components/view-panel'

export const useIntercom = () => {
  const { me, displayName } = useMe()

  const { data: configVarsData } = useQuery(GetConfigVarsDocument, {
    skip: !me?.user,
  })

  const isViewPanelOpen = !!useReactiveVar(globalViewPanelIds).length

  const defaultPadding = 20
  const paddingLeft = isViewPanelOpen ? VIEW_PANEL_WIDTH + defaultPadding : 0
  const paddingBottom = defaultPadding

  const appId = import.meta.env.VITE_INTERCOM_APP_ID
  const isEnabled = configVarsData?.configVars?.intercom
  const email = me?.user?.email
  const userId = me?.user?.id
  const intercomHash = me?.intercomHash

  useEffect(() => {
    if (!isEnabled || !email || !userId || !intercomHash || !appId) {
      return
    }

    Intercom({
      app_id: appId,
      region: 'eu',
      email,
      name: displayName,
      user_id: userId,
      user_hash: intercomHash,
      horizontal_padding: paddingLeft,
      vertical_padding: paddingBottom,
    })
  }, [
    appId,
    displayName,
    email,
    intercomHash,
    isEnabled,
    paddingBottom,
    paddingLeft,
    userId,
  ])
}
